import React from 'react';
import { LagoonContext } from '@src/AppContext/LagoonContext';
import { config } from '@uhg-abyss/web/tools/config';
import { IdleUser } from './IdleUser';

export const SessionTimeout = () => {
  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext.getTable('feature-toggles');
  const useUpdatedAuth = featureToggles.getRow(
    'US10732847_UPDATED_CORE_V2_ENDPOINTS'
  )?.active;

  const onLogout = () => {
    const logoutUrl = useUpdatedAuth
      ? `${config('IDENTITY_API_URL')}/logout/v2`
      : `${config('IDENTITY_API_URL')}/logout`;
    window.location = logoutUrl;
  };

  const handleLogout = async () => {
    onLogout();
  };

  const events = {
    onSignout: () => {
      if (config('APP_ENV') !== 'local') {
        handleLogout();
      }
    },
  };

  return (
    <React.Fragment>
      <IdleUser events={events} />
    </React.Fragment>
  );
};
